import Router from '../utils/router';

import Config from '../configs/main.json';

import PageController from './page';
import ScrollController from './scroll';

import { getRootOffset } from '../helpers';

class RoutingController {

	selector = 'a:not([href*="http"]):not([href*="tel"]):not([href*="mailto"]):not([data-bypass])';

	progress = {};

	currentAnchor = null;

	#ignoreProgress = false;

	#forcedProgress = 0;

	constructor() {
		Router.root = Config.root;

		if (history.scrollRestoration) window.history.scrollRestoration = 'manual';
	}

	start(routes) {
		Router.start(routes);
	}

	navigate(href, history) {
		this.ignoreProgress = true;
		Router.navigate(href, history);
	}

	setProgress(uri, top) {
		this.progress[uri] = top;
	}

	getProgress(uri) {
		return this.progress[uri] || 0;
	}

	getCurrentAnchor() {
		return this.currentAnchor;
	}

	restoreProgress(uri) {
		this.ignoreProgress = true;
		if (this.ignoreProgress) {
			this.ignoreProgress = false;
			if (this.#forcedProgress) {
				ScrollController.scrollTo(this.#forcedProgress, true);
				this.setProgress(uri, this.#forcedProgress);
				this.#forcedProgress = 0;
			} else {
				ScrollController.scrollTo(0, true);
				this.setProgress(uri, 0);
			}
		} else {
			let progress = this.getProgress(uri);
			if (PageController.pages[uri]) {
				const reset = PageController.pages[uri].querySelector('[data-reset-progress]');
				if (reset) {
					const offset = getRootOffset(reset).top;
					if (progress > offset) progress = 0;
				}
			}
			ScrollController.scrollTo(progress, true);
		}
	}

	forceProgress(top) {
		this.#forcedProgress = top;
	}

	#onAnchorClick = (e) => {
		e.preventDefault();
		this.currentAnchor = e.currentTarget;
		this.navigate(e.currentTarget.getAttribute('href'));
	}

	overrideAnchors(container = document) {
		const anchor = container.querySelectorAll(this.selector);
		for (const a of anchor) {
			a.removeEventListener('click', this.#onAnchorClick);
			a.addEventListener('click', this.#onAnchorClick);
		}
	}

}

export default new RoutingController();
